import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import ComponentTable from '../../../Components/Table/Index';
import * as Icon from '@mui/icons-material/';
import { Formik, Field, Form } from 'formik';
//import { OrdemServicoSchema } from '../../../../schemas/OrdemServicoPesquisarSchema';
import useOrderServicoPesquisar from '../../../../hooks/useOrderServicoPesquisar';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { Button } from '../../../../shared/components/button/Button';
import { IconButton } from '@mui/material';
import { InputSelect } from '../../../../shared/components/InputSelect';

export default function OrdemServico() {
  const {
    handleNavigation,
    handleSubmit,
    handleEditItem,
    initialValues,
    tableColumns,
    tableRows,
    itemsStatus,
    selecionadas,
    finalizandoLote,
    handleFinalizarLote,
  } = useOrderServicoPesquisar();

  return (
    <Box
      sx={{
        '& .MuiTextField-root': { m: 1 },
      }}
    >
      <div className={'pb-2'}>
        <HeaderComponent
          className={'mb-6'}
          text={'Ordem de Serviços'}
          ButtonRight={
            <div className={'flex gap-2'}>
              {/* [28/09] Finalização em lote. Fica ao lado do Incluir, como o card pede.
                  Desabilitado enquanto nada está marcado: aqui a caixa vazia é motivo
                  óbvio e visível, diferente das recusas de regra, que vêm do servidor
                  com o número da O.S. */}
              <Button
                className={''}
                variant='primary'
                onClick={handleFinalizarLote}
                iconStart={<Icon.DoneAll />}
                disabled={selecionadas.length === 0 || finalizandoLote}
                title={
                  selecionadas.length > 0
                    ? `Finalizar (${selecionadas.length})`
                    : 'Finalizar'
                }
              />
              <Button
                className={''}
                variant='success'
                onClick={handleNavigation}
                iconStart={<Icon.Add />}
                title={'Incluir'}
              />
            </div>
          }
        />
        <Box mb={2} />

        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          
          onSubmit={handleSubmit}
        >
          {({ errors, setFieldValue, touched }) => (
            <Form className={'grid grid-cols-11'}>
              <Field
                className={'col-span-2'}
                name='os_id'
                as={TextField}
                id='os_id'
                label='Número da OS'
                type='number'
                error={touched.os_id && !!errors.os_id}
                helperText={touched.os_id && errors.os_id}
                onChange={(e: any) => {
                  const { value } = e.target;
                  const newValue = value < 0 ? 0 : value;
                  setFieldValue('os_id', newValue);
                }}
              />
              <Field
                name='os_status'
                as={InputSelect}
                className='col-span-3'
                label='Status'
                type='text'
                items={itemsStatus}                
                handleChange={(event: any) => {
                  const { value } = event.target;
                  setFieldValue('os_status', value);
                }}
                error={Boolean(errors?.os_status)}
                helperText={errors?.os_status}
              />
              <Field
                className={'col-span-3'}
                name='os_clienteNome'
                as={TextField}
                label='Cliente'
                type='text'
              />
              <Field
                className={'col-span-2'}
                name='os_dataEntrega'
                as={TextField}
                label='Data Entrega'
                InputLabelProps={{ shrink: true }}
                type='date'
              />
              <Box className={'pt-3'}>
                <IconButton size={'large'} type={'submit'}>
                  <Icon.Search style={{ fontSize: '28px' }} />
                </IconButton>
              </Box>
            </Form>
          )}
        </Formik>
      </div>
      <ComponentTable columns={tableColumns} rows={tableRows} tableHeight={'65vh'} onRowDoubleClick={(row) => {
        handleEditItem(row, true, row.Id);}} />
    </Box>
  );
}